import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import SupplierShipments from '@components/obsolete/shipment/SupplierShipments.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const SupplierShipmentsListPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <ResponsiveLayout title={tr(`SupplierShipmentsListPage.listSupplierShipments`, `Supplier shipments list`)}>
        <SupplierShipments />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(SupplierShipmentsListPage);
